module.exports = __webpack_public_path__ + "static/media/zeina_arabic.aaee7789.mp3";